export const calcAge = date => {
	if (date) {
		const today = new Date()
		const birthDate = new Date(date)
		var age = today.getFullYear() - birthDate.getFullYear()
		const month = today.getMonth() - birthDate.getMonth()
		if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
			age--
		}
		return age
	}
}

export const findMaxCulture = culture => {
	if (culture) {
		const values = {
			comercial: culture.comercial,
			disruptiva: culture.disruptiva,
			colaborativa: culture.colaborativa,
			tradicional: culture.tradicional,
		}

		const [maxKey, maxValue] = Object.entries(values).reduce(
			(maxEntry, currentEntry) => {
				return currentEntry[1] > maxEntry[1] ? currentEntry : maxEntry
			},
			[null, -Infinity]
		)

		return { label: maxKey, value: maxValue.toFixed(0) }
	}
}

export const getLabel = (list, id) => {
	const item = list.find(l => l.id === id)
	return item ? { id: item.id, value: item.value } : null
}
